<template>
  <div class="createOrder">
    <nav-header module="发单"></nav-header>
    <div class="container">
        <img
          v-if="jobType == 1"
          src="@/assets/createOrder/tag-freedomService.png"
          alt
          class="form-tag"
        />
        <img
          v-if="jobType == 6"
          src="@/assets/createOrder/tag-b2bService.png"
          alt=""
          class="form-tag"
        />
        <img
          v-if="jobType == 8"
          src="@/assets/createOrder/tag-selfService.png"
          alt=""
          class="form-tag"
        />
      <!-- <div class="btn-ghostwritten" @click="ghostwritten">他人代填</div> -->
      <div class="btn-aside" @click="createAgain(1)"  v-if="isShowStep1">导入上一单</div>
      <div class="step-wrapper">
        <form class="form" style="padding-left: 0;padding-right: 0;">
          <div v-if="isShowStep1">
            <div class="form-item">
              <div class="label">服务信息<i class="required">*</i></div>
              <div class="product-box"  v-for="(product, idx) in productionInfoList" :key="'productinfo'+idx">
                <span class="btn-remove" @click="removeProduction(idx)" v-if="productionInfoList.length>1" >删除</span>
                <div class="input-box" style="margin-bottom: 10px;">
                  <input v-if="!product.ServiceOfferName" type="text" class="input" style="border: none;background: none;padding: 0;" v-model.trim="product.ServiceOfferName" autocomplete="off" readonly="readonly" @click="editService(idx)" placeholder="请选择服务（必填）">
                  <div v-else class="input rich" @click="editService(idx)" style="font-size: 16px;font-weight: 600;">{{product.ServiceOfferName}}<i style="font-size: 12px;border-radius: 4px;font-weight: normal;">{{product.DomainName}}</i></div>
                  <span class="unit el-icon-arrow-right" style="right: 0;"></span>
                </div>
                <!-- {{product}} DomainName -->
                  <el-select class="sp-select" filterable v-model="product.BrandId" @change="brandChange(idx)" placeholder="请选择产品品牌（必填）" :loading="product.brandList.length==0">
                    <el-option  :value="item.BrandId" v-for="(item,index) in product.brandList" :key="'Brand'+index" :label="item.BrandName"></el-option>
                  </el-select>
                
                   <el-input class="input-info" v-if="product.BrandId==-2" v-model="product.BrandName" placeholder="请输入品牌"></el-input>
               
                  <el-select class="sp-select" filterable v-model="product.SeriesId" @change="seriesChange(idx)" placeholder="请选择产品系列" :disabled="productionInfoList[idx].BrandId?false:true">
                    <el-option v-for="(item,index) in product.seriesList" :key="'Series'+index" :value="item.SeriesId" :label="item.SeriesName" ></el-option>
                  </el-select>
             
                  <el-input class="input-info" v-if="product.SeriesId==-2" v-model="product.SeriesName" placeholder="请输入系列"></el-input>
              
                <div class="input-box">
                  <input type="text" class="input" v-model.number="product.DeviceCount" placeholder="请填写产品数量（必填）">
                  <span class="unit">台</span>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="input-box">
                <div class="btn-add" @click="addProductFun"><i class="el-icon-plus"></i>新增服务信息</div>
              </div>
            </div>
            <div class="form-item">
              <div class="label">所属行业<i class="required" v-if="showItems.IsIndustryRequired">*</i></div>
              <div class="input-box">
                <el-select 
                  class="sp-select" 
                  filterable 
                  v-model="form.IndustryId" 
                  value-key="SecondIndustryId" 
                  remote
                  :remote-method="filterIndustry"
                  placeholder="请选择所属行业">
                  <el-option  v-for="item in industryList" :key="item.SecondIndustryId" :label="item.FirstLevelIndustryName+'-'+item.SecondIndustryName" :value="item.SecondIndustryId" >
                    <span class="parent" v-html="item.parentName"></span>
                    <span class="child" v-html="item.childName"></span>
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="form-item">
              <div class="label">需工程师数量<i class="required" v-if="showItems.IsEngineerQuantityRequired">*</i></div>
              <div class="input-box">
                <input class="input" v-model.number="form.EngineerCount" type="text" placeholder="请输入工程师数量"/>
                <span class="unit">人</span>
              </div>
            </div>
            <div class="form-item">
              <div class="label">服务需求描述<i class="required" v-if="showItems.IsServiceDescribeRequired">*</i></div>
              <div class="input-box">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3 }"
                  placeholder="请输入服务需求"
                  v-model.trim="form.Content"
                  resize="none"
                  class="demand-textarea"
                  >
                </el-input>
                <!-- <textarea class="textarea" v-model.trim="form.Content" placeholder="请输入故障现象及服务需求"></textarea> -->
              </div>
            </div>
            <div class="form-item">
              <div class="label">现场资料<i class="required" v-if="showItems.IsSiteDataUploadRequired">*</i></div>
              <div class="input-box">
                <ul class="img-list">
                  <li v-for="(item,index) in imgList" :key="'img'+index">
                    <i class="icon-close el-icon-close" @click="removeImg(index)"></i>
                    <img v-if="/jpg|png|gif|jpeg/.test(item.fileExt)" :src="item.imgUrl" preview="1" :preview-text="item.fileName" alt="">
                    <img v-if="/doc|docx/.test(item.fileExt)" src="static/file/icon_doc.jpg" alt="">
                    <img v-if="/excel|xls|xlsx/.test(item.fileExt)" src="static/file/icon_excel.jpg" alt="">
                    <img v-if="/\.pdf/.test(item.fileExt)" src="static/file/icon_pdf.jpg" alt="">
                    <img v-if="/\.zip/.test(item.fileExt)" src="static/file/icon_zip.jpg" alt="">
                    <img v-if="/\.rar/.test(item.fileExt)" src="static/file/icon_rar.jpg" alt="">
                    <img v-if="/\.ppt/.test(item.fileExt)" src="static/file/icon_ppt.jpg" alt="">
                  </li>
                  <li>
                    <el-upload
                      class="btn-upload"
                      v-if="imgList.length<6"
                      :action="UploadImg"
                      :on-success="uploadSuccess"
                      :before-upload="beforeUpload"
                      :show-file-list="false"
                    >
                      <i class="icon-file el-icon-plus"></i>
                    </el-upload>
                  </li>
                </ul>
                <p class="remark">注：上传现场照片及相应文档。最多6个，单个文件不超过60M，格式为：jpg/png/rar/doc/pdf/ppt/excel..等</p>
              </div>
            </div>
            <div class="form-item" v-if="jobType==1||B2bIsFreeToB2b" style="min-height: 126px;">
              <div class="label">发单类别</div>
              <div class="input-box" style="padding: 5px;">
                <el-radio-group v-model="IsFreeToB2b">
                    <el-radio :label="1" >速派自营</el-radio>
                    <el-radio :label="0" >众包专区</el-radio>
                </el-radio-group>

               <table class="jobTypeDesc">
                <tr style="    background: #f5f7fa;">
                    <td style="width:195px">工单类别</td>
                    <td>速派自营(推荐)</td> 
                    <td>众包专区</td>
                  </tr>
                  <tr>
                    <td>速派保证服务质量和最终交付</td>
                    <td><i class="el-icon-check"></i></td> 
                    <td> <i class="el-icon-close" style="color: #606266;"></i></td>
                  </tr>
                  <tr>
                    <td>专属客服</td>
                    <td> <i class="el-icon-check"></i></td>
                    <td> <i class="el-icon-close"  style="color: #606266;"></i></td>
                  </tr>
                  <tr>
                    <td>平台监管</td>
                    <td><i class="el-icon-check"></i></td>
                    <td><i class="el-icon-close"  style="color: #606266;"></i></td>
                  </tr>
                  <tr>
                    <td>技术专家支持</td>
                    <td> <i class="el-icon-check"></i></td>
                    <td><i class="el-icon-close"  style="color: #606266;"></i></td>
                  </tr>
                  <tr>
                    <td>标准服务流程</td>
                    <td> <i class="el-icon-check"></i></td>
                    <td> <i class="el-icon-check"></i></td>
                  </tr>
                  <tr>
                    <td>保险（意外险和责任险）</td>
                    <td> <i class="el-icon-check"></i></td>
                    <td> <i class="el-icon-check"></i></td>
                  </tr>
                  <tr>
                    <td>6%增值税发票</td>
                    <td><i class="el-icon-check"></i></td>
                    <td><i class="el-icon-check"></i></td>
                  </tr>
                  <tr>
                    <td>价格</td>
                    <td> 精英工程师标准价格</td>
                    <td>工程师投标竞价</td>
                  </tr>
                  <tr>
                    <td>取消工单收费</td>
                    <td><span class="thr">¥200</span>限时折扣¥100 </td>
                    <td>¥15</td>
                  </tr>
               </table>
              </div>
            </div>
          </div>
          <div v-if="!isShowStep1">
            <div class="module-title">特殊需求</div>
            <div class="special-demand">
              <div class="demand-list" v-for="(item,index) in ServiceProblemList" :key="index">
                <div class="demand-title">{{item.Title}}<i class="required" v-if="item.IsRequired">*</i></div>
                <div>
                  <template v-if="item.ProblemType == 1">
                    <el-select class="sp-select" v-model="item.radio" placeholder="请选择" @change="$forceUpdate()">
                      <el-option
                        v-for="items in item.ProblemOptionList"
                        :key="items.Id"
                        :label="items.Content"
                        :value="items.Id">
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else-if="item.ProblemType == 2">
                      <el-select class="sp-select" v-model="item.checkbox" multiple placeholder="请选择"  @change="$forceUpdate()">
                        <el-option
                          v-for="items in item.ProblemOptionList"
                          :key="items.Id"
                          :label="items.Content"
                          :value="items.Id">
                        </el-option>
                      </el-select>
                  </template>
                  <template v-else>
                    <template v-if="item.ProblemOptionList.length">
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 3 }"
                        placeholder="请输入"
                        v-model.trim="item.content"
                        resize="none"
                        class="demand-textarea"
                        @input="$forceUpdate()"
                        >
                      </el-input>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="form-item btn-group">
            <div v-if="isShowStep1" class="btn-primary" @click="nextStep">下一步</div>
            <div v-if="!isShowStep1" class="btn-default" @click="isShowStep1=true">上一步</div>
            <div v-if="!isShowStep1" class="btn-primary" @click="submit">下一步</div>
          </div>
        </form>
      </div>
    </div>
    <page-footer></page-footer>
    <div class="qrcode-dialog" v-show="showQrcode">
      <div class="inner">
        <input class="hide-input" type="url" ref="copy" :value="link" />
        <span class="btn-copy" @click="copyUrl">复制链接</span>
        <img :src="qrcode" alt="" class="qrcode" />
        <span class="desc"
          >该二维码和链接1小时内有效，您可转发
          他人完成工单信息填写。对方完成填写 后，重新点击发单即可获取内容</span
        >
        <button class="btn-primary" @click="showQrcode = false">确定</button>
      </div>
    </div>
    <div class="guide-box" v-if="showGuide" @click="closeGuide">
      <img src="@/assets/createOrder/guide.png" alt="" />
    </div>

    <!-- 选择服务 -->
    <el-dialog
      title=" "
      class="select-service"
      :visible.sync="serviceShow"
      width="1000px"
      :close-on-click-modal="false"
      @close="serviceShow=false;$refs.service.clearId()"
      >
      <div>
        <service-center ref="service" @setOptionRow="setOptionRow"></service-center>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navHeader from "@/components/navHeader.vue";
import footer from "@/components/footer.vue";
import serviceCenter from '@/components/serviceCenter.vue'
import {
  CreateReplaceSendJobQrCode,
  GetAccountJobConfig,
  ServiceStagesByDomain,
  GetDropDownIndustryList,
  AddJobDetail,
  ProductBrands,
  ProductDomains,
  // GetReplaceSendJob, //代发
  GetRepublishSendJob,
  UploadImg,

  GetUserSendJobInfo,     //获取是否有草稿
  GetBrandList,             //获取品牌
  GetSeriesList,            //获取系列
  GetJobDisposeSet,         //new获取配置
  AddJobOne,                //提交发单第一步
  GetServiceProblem,        //获取第二步特殊需求
  AddJobTwo,                //提交第二步

} from "@/scripts/api.js";
import { mapState } from "vuex";
import valid from '@/scripts/validate.js'
export default {
  name: "createStep1",
  components: {
    navHeader,
    "page-footer": footer,
    serviceCenter,
  },
  data() {
    return {
      UploadImg,
      qrcode: "",
      link: "",
      showQrcode: false,
      showGuide: false,
      showItems:'',
      fieldList:[],
      level1:'',
      productionInfoList:[{
        serviceStage:[],
        productionList:[],
        brandList:[],
        seriesList:[],
        ServiceStageId:'',
        ServiceStageName:'',
        ServiceType:'',//1:项目，2：标准
        DomainId:'',
        DomainName:'',
        ProductCategoryID:'',
        ProductCategoryName:'',
        BrandId:'',
        BrandName:'',
        SeriesId:'',
        SeriesName:'',
        DeviceCount:1,
      }],
      industryList:[],
      markList:[],
      specialList:[],//特殊需求
      isShowStep1:true,
      isShowSpecial:false,
      B2bIsFreeToB2b:false,//自由转b2b的单子，再来一单时，要显示选专属客户
      IsFreeToB2b:-1,//0不转，1转
      form:{
        ProductLineList :[],
        IndustryId:'',
        EngineerCount:'1',
        Content:'',
        FileUrlList:[],
        // Symptom:'',
        // Aptitude:'',
        // ExtendValueList:[],
        CreateStartTime: '',    //开始时间
   
      },
      imgList:[],  
      jobType:1,//1:自由工单，6:B2B工单，8:内部工单
      agencyId:0,
      otherDomainId:2147483647,//其他领域id
      industryKey:'', 
      serviceShow: false, 
      JobId: '',                  //工单id
      IsB2BProjectJob: Boolean,   //是否是项目型工单
      ServiceProblemList: null,   //特殊需求
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      // productions:state=>state.productions,
    })

    // isSelectMarket(){
    //   return !this.IsFreeToB2b;
    // }
  },
  beforeRouteEnter(to, from, next) {
    next(vm=>{
      console.log("beforeRouteEnter触发");
      if (to.path == '/createStep1' && from.path != '/createStep2') {
        let flag=vm.showItems==''?true:false;
        // console.log(flag);
        vm.showItems='';
        vm.fieldList=[];
        vm.level1='';
        vm.productionInfoList=[{
          serviceStage:[],
          productionList:[],
          brandList:[],
          seriesList:[],
          ServiceStageId:'',
          ServiceStageName:'',
          ServiceType:'',//1:项目，2：标准
          DomainId:'',
          DomainName:'',
          ProductCategoryID:'',
          ProductCategoryName:'',
          BrandId:'',
          BrandName:'',
          SeriesId:'',
          SeriesName:'',
          ServiceOfferId: '',
          ServiceOfferName: '',
          DeviceCount:1,
        }];
        vm.industryList=[];
        vm.markList=[];
        vm.specialList=[];//特殊需求
        vm.isShowStep1=true;
        vm.isShowSpecial=false;
        vm.form={
          ProductLineList :[],
          IndustryId:'',
          EngineerCount:'1',
          Content:'',
          FileUrlList:[],

          // Symptom:'',
          // Aptitude:'',
          // ExtendValueList:[],
        };
        vm.imgList=[];
  
      
        vm.agencyId=0;
        vm.industryKey='';
        vm.jobType = Number(to.query.jobType) || 1;  //1:自由工单，6:B2B工单，8:内部工单
        vm.IsFreeToB2b=  -1; //-1默认，0不转，1转
        vm.goTime = ''
        vm.loadList();
        vm.pageInit();
      }
    });
  },
  created() { 
 
  },
  activated() {
    //显示发单指引
    // var hasGuide = localStorage.getItem("hasGuide");
    // if (!hasGuide) {
    //   this.showGuide = true;
    // }
    this.form.CreateStartTime = this.$formatTime(new Date())
  },
  mounted(){ 
    this.loadBrandList();
  }, 
  methods: {
    GetUserSendJobInfoFun(){
      let data = {
        UserCode: this.userInfo.UserCode
        // UserId: this.userInfo.LoginAccountId
        
      }
      GetUserSendJobInfo(data).then(r=>{
        if(r.Result != 1) {
          return
        }
        if(r.Data.DraftJobId != 0) {
            this.$confirm('有未完成工单, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.createAgain(3,r.Data.DraftJobId)
          }).catch(() => {});
        }
      })
    },
    //关闭发单指引
    closeGuide() {
      this.showGuide = false;
      localStorage.setItem("hasGuide", "true");
    },
    //页面初始化
    pageInit() {
      if(this.$route.query.jobId){
        this.createAgain(2,this.$route.query.jobId);
      }else{
        this.GetUserSendJobInfoFun()
      }
      console.log("pageInit-jobType:"+this.jobType);
      console.log("pageInit-isFreeToB2b:"+this.IsFreeToB2b);
    },
    // 获取配置
    getJobDisposeSet(){
      let data = {}
      data.ServiceOfferIdArray = this.productionInfoList.map((item)=>{
        return item.ServiceOfferId
      })
      data.UserCode= this.userInfo.UserCode
      data.JobType= this.jobType
      GetJobDisposeSet(data).then(r=> {
        if (r.Result == 1) {
          this.showItems=r.Data;
        }
      })
      
    },
    //取值参数
    setQuery(){
      let query={
        ...this.$route.query
      };
      this.jobType=Number(query.jobType); 
      this.productionInfoList[0].brandList=[];
      this.productionInfoList[0].seriesList=[];
      this.productionInfoList[0].ServiceOfferName=query.ServiceOfferName;
      this.productionInfoList[0].ServiceOfferId=query.ServiceOfferId;
      this.productionInfoList[0].DomainId=query.DomainId || '';
      this.productionInfoList[0].DomainName=query.DomainName;
      this.productionInfoList[0].ProductCategoryID=query.ProductCategoryID;
      this.productionInfoList[0].BrandId='';
      this.productionInfoList[0].BrandName='';
      this.productionInfoList[0].SeriesId='';
      this.productionInfoList[0].SeriesName='';
      this.productionInfoList[0].DeviceCount=1;
      this.loadBrandList()
      this.getJobDisposeSet();
      
    },

    // 获取品牌
    loadBrandList(index=0){
      GetBrandList({
        platform:'pcweb',
        IsAddWu:true
      }).then(r=>{
        if(r.Result==1){
          this.$nextTick(()=>{
            let list=r.Data || [];
            let product={...this.productionInfoList[index]};
            product.brandList=list; 
            this.$set(this.productionInfoList,index,product);
          })
        }
      })
    },
    // 所属行业
    filterIndustry(data){
      this.industryKey=data;
      this.loadIndustry();
    },
    loadList(){
      //一级服务类型
      ProductDomains({
        IsReturnOtherDomain:true,
        platform:'pcweb',
      }).then(r=>{
        if(r.Result==1){
          this.fieldList=r.Data;
          this.setQuery();
        }
      })
      this.loadIndustry();
    },
      // 行业列表
    loadIndustry(){
      GetDropDownIndustryList({
        platform:'pcweb',
        IndustryName:this.industryKey
      }).then(r=>{
        if(r.Result==1){
          let list=r.Data ||[];
          list.map(item=>{
            if(this.industryKey.trim()!==''&& item.FirstLevelIndustryName.indexOf(this.industryKey)!=-1){
              item['parentName']=item.FirstLevelIndustryName.replace(this.industryKey,`<i>${this.industryKey}</i>`);
            }else{
              item['parentName']=item.FirstLevelIndustryName;
            }
            if(this.industryKey.trim()!==''&& item.SecondIndustryName.indexOf(this.industryKey)!=-1){
              item['childName']=item.SecondIndustryName.replace(this.industryKey,`<i>${this.industryKey}</i>`);
            }else{
              item['childName']=item.SecondIndustryName;
            }
          })
          this.industryList=list;
        }
      })
    },
    //获取再发一单的信息
    createAgain(action,jobId){
      let params={};
      params.ActionType = action
      params.UserCode = this.userInfo.UserCode
      params.JobType = Number(this.$route.query.jobType)
      if(!isNaN(jobId)){
        params['JobId']=jobId;
      }
      GetRepublishSendJob(params).then(r=>{
        if(r.Result==1 && r.Data.FirstStep){
          let step1=r.Data.FirstStep

          //form对象
          for (let i = 0; i < this.industryList.length; i++) {
            if(this.industryList[i].SecondIndustryId==step1.IndustryId){
              this.form.IndustryId=step1.IndustryId;
            }
          }
          this.form.Symptom=step1['Symptom'];
          this.form.Content=step1['Content'];
          this.form.EngineerCount=step1['EngineerCount'];
          this.form.Aptitude=step1['Aptitude'];

          if(r.Data.FirstStep.JobType==6&&r.Data.FirstStep.IsFreeToB2b)
          {
            this.B2bIsFreeToB2b=true;//自由转b2b的单子，再来一单时，要默认选专属客户
            this.IsFreeToB2b=1;
            this.jobType=1;//自由转b2b的单子，再来一单时，设置jobType=1，还走自由转b2b的流程

            console.log("  再来一单 this.jobType："+   this.jobType);
          }

          //图片数据
          let imgs=step1.FileUrlList || [];
          this.imgList=[];
          for (let i = 0; i < imgs.length; i++) {
            let obj={};
            obj.imgUrl=imgs[i];
            obj.fileExt=imgs[i].substr(imgs[i].lastIndexOf('.'));
            this.imgList.push(obj);
          }


          //产品数据
          let productList=step1.ProductLineList;
          for (let i = 0; i < productList.length; i++) {
            let {
                DomainId,
                DomainName,
                ServiceStageId,
                ServiceStageName,
                ProductCategoryID,
                ProductCategoryName,
                BrandId,
                BrandName,
                SeriesId,
                SeriesName,
                DeviceCount,
                ServiceOfferId,
                ServiceOfferName,
                ServiceType
              }=productList[i];
            if(this.productionInfoList[i]){
              this.productionInfoList[i].DomainId=DomainId;
              // this.productionInfoList[i].DomainName=DomainName;
              this.productionInfoList[i].DomainName=ProductCategoryName;
              this.productionInfoList[i].ServiceStageId=ServiceStageId;
              this.productionInfoList[i].ServiceStageName=ServiceStageName;
              this.productionInfoList[i].ProductCategoryID=ProductCategoryID;
              this.productionInfoList[i].ProductCategoryName=ProductCategoryName;
              this.productionInfoList[i].BrandId=BrandId;
              this.productionInfoList[i].BrandName=BrandName;
              this.productionInfoList[i].SeriesId=SeriesId;
              this.productionInfoList[i].SeriesName=SeriesName;
              this.productionInfoList[i].DeviceCount=DeviceCount || 1;
              // this.productionInfoList[i].serviceStage=serviceSateList;
              this.productionInfoList[i].serviceStage=[];
              // this.productionInfoList[i].productionList=productionList;
              this.productionInfoList[i].productionList=[];
              this.productionInfoList[i].ServiceOfferId=ServiceOfferId;
              this.productionInfoList[i].ServiceOfferName=ServiceOfferName;
              this.productionInfoList[i].ServiceType=ServiceType?1:2;
            }else{
              this.productionInfoList[i]={
                // serviceStage:serviceSateList,
                serviceStage:[],
                // productionList:productionList,
                productionList:[],
                brandList:[],
                seriesList:[],
                ServiceType:ServiceType?1:2,
                DomainId,
                DomainName,
                ServiceStageId,
                ServiceStageName,
                ProductCategoryID,
                ProductCategoryName,
                BrandId,
                BrandName,
                SeriesId,
                SeriesName,
                DeviceCount,
                ServiceOfferId,
                ServiceOfferName
              }
            }
            this.brandChange(i)
            this.getJobDisposeSet()
            this.$forceUpdate();
          }
          this.$store.commit('setPublishAgain',r.Data);
        }else{
          this.$toast(r.Message);
        }
      })
    },
    //选择领域
    categoryChange(index=0,isSet=false){
      if(!isSet){
          this.loadBrandList(index)
      }
      this.$forceUpdate();
    },
    // 选择品牌
    brandChange(index){
      let product={...this.productionInfoList[index]};
   
      if(product.BrandId!=-2){ 
        for (let i = 0; i < product.brandList.length; i++) {
          if(product.brandList[i].BrandId==product.BrandId){ 
            product.BrandName= product.brandList[i].BrandName; 
          }
        }
      }
      else{ 
        product.BrandName=''; 
      }

      // console.log('BrandId:'+product.BrandId+';BrandName:'+  product.BrandName);
      GetSeriesList({
        ProductId: product.ProductCategoryID,
        BrandId: product.BrandId,
        IsAddWu:true
      }).then(r=>{
        if(r.Result==1){
          this.$nextTick(()=> {
            let list=r.Data || [];
            product.seriesList=list;
            this.$set(this.productionInfoList,index,product);
 
            this.$forceUpdate(); 
          })
        }
      })
    },
    // 选择系列
    seriesChange(index){
      let product={...this.productionInfoList[index]};

    if(product.SeriesId!=-2){
          for (let i = 0; i < product.seriesList.length; i++) {
            if(product.seriesList[i].SeriesId==product.SeriesId){
              product.SeriesName= product.seriesList[i].SeriesName;
            }
          } 
      }
      else{ 
        product.SeriesName=''; 
      }

      this.$set(this.productionInfoList,index,product);
      this.$forceUpdate();
    },
    // new 新增产品
    addProductFun(){
      this.serviceShow=true
      this.$nextTick(()=> {
        this.$refs.service.getSelection();
      })
    },

    // 选择服务返回
    setOptionRow(val,idx){
      let index = 0
      if(idx !== null && idx>=0) {
          index = idx
          this.productionInfoList[index].brandList=[];
          this.productionInfoList[index].seriesList=[];
          this.productionInfoList[index].ServiceOfferName=val.serviceName;
          this.productionInfoList[index].ServiceOfferId=val.id;
          this.productionInfoList[index].DomainId=val.domainId || '';
          // this.productionInfoList[index].DomainName=val.domainName;
          this.productionInfoList[index].DomainName=val.firstProductName;
          this.productionInfoList[index].ProductCategoryID=val.thirdProductId;
          this.productionInfoList[index].BrandId='';
          this.productionInfoList[index].BrandName='';
          this.productionInfoList[index].SeriesId='';
          this.productionInfoList[index].SeriesName='';
          this.productionInfoList[index].DeviceCount=1;
      }else{
        index=this.productionInfoList.length;
        this.productionInfoList.push({
          brandList:[],
          seriesList:[],
          ServiceOfferName: val.serviceName,
          ServiceOfferId: val.id,
          DomainId: '',
          // DomainName: val.domainName,
          DomainName: val.firstProductName,
          ProductCategoryID: val.thirdProductId,
          BrandId:'',
          BrandName: '',
          SeriesId:'',
          SeriesName: '',
          DeviceCount:1,
        })
        if(this.productionInfoList.length==2&&this.jobType == 6) {
          this.$toast('本单已改成项目议价')
        }
      }
      this.serviceShow = false;
      this.$refs.service.clearId();
      this.getJobDisposeSet()
      this.categoryChange(index);
    },
    //修改服务
    editService(index){
      let product={...this.productionInfoList[index]};
      this.serviceShow=true
      this.$nextTick(()=> {
        this.$refs.service.getSelection(product.ServiceOfferName,index);
      })
    },
    //确认添加产品
    validProduct(item){

      if(item.ServiceOfferName === ''){
        this.$toast('请选择服务！');
        return false;
      }else if(this.showItems.IsProductBrandRequired && item.BrandId === '') {
        this.$toast('请选择产品品牌！');
        return false;
      }else if (this.showItems.IsProductSerialRequired && item.SeriesId === '') {
        this.$toast('请选择产品系列！');
        return false;
      }else if(!valid.positiveInt(item.DeviceCount) && item.DeviceCount!=='') {
        this.$toast('故障设备数量为正整数！');
        return false;
      }
      return true;
    },
    // 删除产品信息
    removeProduction(index){
      this.productionInfoList.splice(index,1);
    },
    //他人代发
    ghostwritten() {
      CreateReplaceSendJobQrCode({
        UserCode: this.userInfo.UserCode,
        JobType: this.jobType,
        platform: "pcweb",
      }).then((r) => {
        if (r.Result == 1) {
          this.qrcode = r.Data.QrImgUrl;
          this.link = r.Data.LinkUrl;
          this.showQrcode = true;
        } else {
          this.$toast(r.Message);
        }
      });
    },
    //上传之前
    beforeUpload(file){
      let isLtSize = file.size / 1024 / 1024 < 60;
      if (!isLtSize) {
        this.$toast('上传文件大小不能超过 60MB!');
      }
      let fileType=file.name.substr(file.name.lastIndexOf('.'));
      let fileArr=['.jpg','.jpeg','.gif','.png','.rar','.doc','.docx','.pdf','.ppt','.pptx','.excel','.xls','.xlsx']
      let isFileAllowed=fileArr.indexOf(fileType.toLowerCase())!==-1;
      if (!isFileAllowed) {
        this.$toast('上传文件格式不允许!');
      }
      return isLtSize && isFileAllowed;
    },
    //上传成功
    uploadSuccess(file,res){
      if(file.Result==1){
        this.imgList=this.imgList.concat(file.Data);
      }else{
        this.$toast(file.Message);
      }
    },
    //删除上传资料
    removeImg(index){
      this.imgList.splice(index,1);
    },
    // 下一步
    nextStep(){
      // AddJobOne
      let items={...this.showItems};
      let form={...this.form};
      let productFill=false;
      let productionLine = []
      for (let i = 0; i < this.productionInfoList.length; i++) {
        let _obj = this.productionInfoList[i];
        productFill=this.validProduct(_obj);
      }
      if(!productFill){
        return;
      }
      if(items.IsIndustryRequired && form.IndustryId==''){
        this.$toast('请选择所属行业');
        return;
      }
      
      if(items.IsEngineerQuantityRequired && form.EngineerCount==''){
        this.$toast('请输入工程师数量');
        return;
      }
      if(items.IsEngineerQuantityRequired && !valid.positiveInt(form.EngineerCount)){
        this.$toast('工程师数量为正整数！');
        return;
      }
      if(items.IsServiceDescribeRequired && form.Content==''){
        this.$toast('请输入服务需求描述');
        return;
      }
      if(items.IsSiteDataUploadRequired && this.imgList.length==0){
        this.$toast('请上传现场资料');
        return;
      }
      console.log('IsFreeToB2b:'+this.IsFreeToB2b+";jobType:"+this.jobType);
      if(this.jobType==1&&this.IsFreeToB2b<=-1)
      {
        this.$toast('请选择发单类别');
        return;
      }
      for (let i = 0; i < this.productionInfoList.length; i++) {
        let {ServiceOfferId,BrandId,BrandName,SeriesId,SeriesName,DeviceCount} = {...this.productionInfoList[i]}
        productionLine.push({
          ServiceOfferId,BrandId,BrandName,SeriesId,SeriesName,DeviceCount
        })
      }
      let fileArr=[];
      for (let i = 0; i < this.imgList.length; i++) {
        fileArr[i] = this.imgList[i].imgUrl;
      }
       
      
      let params={
        ...form,
        // UserId: this.userInfo.LoginAccountId,
        UserCode: this.userInfo.UserCode,
        DisposeId:items.Id,
        ProductLineList:productionLine,
        FileUrlList:fileArr,
        jobType: this.jobType
      };

      if(this.$route.query.jobId==0&&this.jobType==6){//直接发b2b时
        params.IsFreeToB2b=false;
      }
      else
      { 
        params.IsFreeToB2b=this.IsFreeToB2b==1 ; 
      }
    
      AddJobOne(params).then(res=> {
        if(res.Result != 1) {
          return this.$toast(res.Message);
        }
        console.log(res)
        this.JobId = res.Data.JobId
        this.IsB2BProjectJob = res.Data.IsB2BProjectJob
        if(res.Data.IsHasSpecialProblem) {
          this.isShowStep1=false;
          let data = {
            JobId: res.Data.JobId
          }
          // if(!this.ServiceProblemList) {
            GetServiceProblem(data).then(r=> {
              this.ServiceProblemList = r.Data.ServiceProblemList
              for (let i = 0; i < this.ServiceProblemList.length; i++) {
                if(this.ServiceProblemList[i].ProblemType == 1) {
                  this.ServiceProblemList[i].radio= ''
                  for(let j = 0; j<this.ServiceProblemList[i].ProblemOptionList.length; j++) {
                    if(this.ServiceProblemList[i].ProblemOptionList[j].IsChecked) {
                      this.ServiceProblemList[i].radio = this.ServiceProblemList[i].ProblemOptionList[j].Id
                    }
                  }
                }else if(this.ServiceProblemList[i].ProblemType == 2) {
                  this.ServiceProblemList[i].checkbox = []
                    for(let j = 0; j<this.ServiceProblemList[i].ProblemOptionList.length; j++) {
                      if(this.ServiceProblemList[i].ProblemOptionList[j].IsChecked) {
                        this.ServiceProblemList[i].checkbox.push(this.ServiceProblemList[i].ProblemOptionList[j].Id)
                      }
                    }
                }else {
                  this.ServiceProblemList[i].content = ''
                  for(let j = 0; j<this.ServiceProblemList[i].ProblemOptionList.length; j++) {
                    if(this.ServiceProblemList[i].ProblemOptionList[j].Content != '') {
                      this.ServiceProblemList[i].content = this.ServiceProblemList[i].ProblemOptionList[j].Content
                    }
                  }
                }
              }
            })
  
          // }
        }else {
          let ServiceOfferIdArray = this.productionInfoList.map((item)=>{
            return item.ServiceOfferId
          })
          let orderName = this.productionInfoList[0].ServiceOfferName;

          var jobType= this.jobType;
          if(jobType==1&&this.IsFreeToB2b==1) //自由转b2b
          {
            jobType=6;
          }
          this.$router.push({
            path:'/createStep2',
            query:{
              jobId:this.JobId,
              ServiceOfferId: ServiceOfferIdArray.join(','),
              jobTitle:orderName,
              isProject:this.IsB2BProjectJob,
              jobType: jobType
            }
          })
          // alert('跳转第三步')
        }
      })
    },
    //保存
    submit(){
      let data = {}
      let JobSpecialRequireList = []
      let orderName = this.productionInfoList[0].ServiceOfferName;
      for(let i in this.ServiceProblemList) {
        if(this.ServiceProblemList[i].IsRequired) {
          if(this.ServiceProblemList[i].ProblemType == 1) {
            if(this.ServiceProblemList[i].radio == '') {
              return this.$toast('请选择'+this.ServiceProblemList[i].Title);
            }
          }else if(this.ServiceProblemList[i].ProblemType == 2) {
            if(!this.ServiceProblemList[i].checkbox.length) {
              return this.$toast('请选择'+this.ServiceProblemList[i].Title);
            }
          }else {
            if(this.ServiceProblemList[i].content == '') {
              return this.$toast('请输入'+this.ServiceProblemList[i].Title);
            }
          }
        }
        let obj = {
          ServiceProblemId: this.ServiceProblemList[i].Id,
          SelectProblemOptionIdArray: [],
          AnswerContent:''
        };
        if(this.ServiceProblemList[i].ProblemType == 1) {
          obj.SelectProblemOptionIdArray.push(this.ServiceProblemList[i].radio)
        }else if(this.ServiceProblemList[i].ProblemType == 2) {
          obj.SelectProblemOptionIdArray = this.ServiceProblemList[i].checkbox
        }else {
          obj.AnswerContent = this.ServiceProblemList[i].content
        }
        JobSpecialRequireList.push(obj)
      }
      let ServiceOfferIdArray = this.productionInfoList.map((item)=>{
        return item.ServiceOfferId
      })
      data.JobId = this.JobId
      data.JobSpecialRequireList = JobSpecialRequireList

      AddJobTwo(data).then(r=> {
        // console.log(r)
          if(r.Result==1){
            var jobType= this.jobType;
            if(jobType==1&&this.IsFreeToB2b==1) //自由转b2b
            {
              jobType=6;
            }
           this.$router.push({
            path:'/createStep2',
            query:{
              jobId:this.JobId,
              ServiceOfferId: ServiceOfferIdArray.join(','),
              jobTitle:orderName,
              isProject:this.IsB2BProjectJob,
              jobType: jobType
            }
          })
        }else{
          this.$toast(r.Message);
        }
      })
    },
    //复制链接
    copyUrl() {
      if (!this.link) {
        return;
      }
      this.$refs.copy.focus();
      this.$refs.copy.select();
      document.execCommand("Copy");
      this.$toast("复制成功！");
    } 
    
  },
};
</script>

<style lang="scss">
.createOrder {
  background-color: #f9f9f9;
  min-height: 100vh;
  padding-top: 68px;
  overflow: hidden;
  .header-main {
    width: 1000px;
  }
  .container {
    width: 1000px;
    margin: 40px auto;
    background-color: #fff;
    border-top: 3px solid #f75959;
    position: relative;
    min-height: 80vh;
    .btn-ghostwritten {
      position: absolute;
      right: 0;
      top: 273px;
      z-index: 2;
      width: 84px;
      height: 32px;
      background-color: #f75959;
      font-size: 14px;
      color: #fff;
      line-height: 32px;
      text-align: center;
      border-radius: 50px 0 0 50px;
      box-shadow: 0 3px 6px rgba(100, 100, 100, 0.3);
      cursor: pointer;
      user-select: none;
    }
    .btn-aside{
      position: absolute;
      right: 0;
      top: 330px;
      z-index: 2;
      width: 84px;
      height: 32px;
      background-color: #f75959;
      font-size: 14px;
      color: #fff;
      line-height: 32px;
      text-align: center;
      border-radius: 50px 0 0 50px;
      box-shadow: 0 3px 6px rgba(100, 100, 100, 0.3);
      cursor: pointer;
      user-select: none;
    }
    .form-tag {
      position: absolute;
      right: -6px;
      top: -6px;
      z-index: 2;
      width: 137px;
      height: 137px;
    }
  }
  .step-wrapper {
    .form {
      width: 700px;
      margin: 20px auto 0;
      padding-bottom: 70px;
    }
    .form-item {
      position: relative;
      margin-bottom: 20px;
      overflow: hidden;
    }
    .input-box {
      min-height: 40px;
      position: relative;
      overflow: hidden;
      width: 600px;
      float: right;
    }
    .form-item .label {
      font-size: 14px;
      line-height: 20px;
      font-weight: bold;
      padding: 10px 0;
      color: #333;
      width: 100px;
      float: left;
      padding-right: 8px;
    }
    .form-item .input {
      width: 100%;
      height: 40px;
      border: 1px solid #e3e3e3;
      font-size: 14px;
      color: #333;
      padding: 8px 10px;
      line-height: 22px;
      &.rich {
        border: none;
        background: none;
        padding: 0;
        line-height: 40px;
        display: flex;
        align-items: center;
        i {
          display: inline-block;
          vertical-align: top;
          height: 20px;
          border: 1px solid #EC7A2D;
          font-size: 12px;
          color: #F75959;
          padding: 0 4px;
          margin-left: 6px;
          line-height: 18px;
        }
      }
    }
    .textarea {
      resize: none;
      width: 100%;
      height: 80px;
      border: 1px solid #e3e3e3;
      font-size: 14px;
      color: #333;
      line-height: 22px;
      padding: 8px 10px;
    }
    .demand-textarea {
      .el-textarea__inner:focus {
          outline: 0;
          border-color: #e5e5e5;
      }
    }
    .btn-add {
      width: 100%;
      height: 40px;
      border: 1px solid #e3e3e3;
      text-align: center;
      font-size: 14px;
      color: #f75959;
      line-height: 38px;
      cursor: pointer;
    }
    .btn-upload {
      display: block;
      position: relative;
      width: 80px;
      height: 80px;
      overflow: hidden;
      margin-bottom: 10px;
    }
    .icon-file {
      display:inline-block;
      position: relative;
      width: 80px;
      height: 80px;
      border: 1px solid #e3e3e3;
      cursor:pointer;
      text-align: center;
      line-height: 80px;
      font-size: 40px;
      color: #e3e3e3;
    }
    .el-date-editor {
      display: block;
      width: 100%;
    }
    .el-date-editor {
      .el-input__inner {
        padding-left: 10px;
        border-radius: 0;
      }
      .el-icon-date {
        display: none;
      }
      .el-input__suffix {
        right: 30px;
      }
      &:after {
        content: "";
        position: absolute;
        right: 0px;
        top: 10px;
        z-index: 2;
        width: 30px;
        height: 20px;
        background: url("~@/assets/createOrder/icon-calendar.png")
          no-repeat right center;
      }
    }
    .el-select .el-input__inner {
      padding-left: 10px;
      border-radius: 0;
    }
    .form-item .remark {
      font-size: 14px;
      color: #999;
      line-height: 24px;
      display: block;
      margin-top: -6px;
    }
    .form-item .unit {
      position: absolute;
      right: 10px;
      top: 0px;
      z-index: 2;
      font-size: 14px;
      color: #999;
      line-height: 40px;
    }
    .form-item .btn-primary,
    .form-item .btn-default  {
      width: 120px;
      height: 40px;
      font-size: 16px;
      line-height: 40px;
    }
    .btn-group{
      text-align: center;
    }
    .btn-default {
      display: inline-block;
      background: #fff;
      border-radius: 2px;
      font-family: inherit;
      color: #f75959;
      text-align: center;
      cursor: pointer;
      border: 1px solid #f75959;
      &+.btn-primary{
        margin-left: 20px;
      }
    }
    .btn-primary {
      display: inline-block;
      background: #f75959;
      border-radius: 2px;
      font-family: inherit;
      color: #fff;
      text-align: center;
      cursor: pointer;
      border: 1px solid #f75959;
    }
    .form-item .remark {
      font-size: 14px;
      color: #999;
      line-height: 24px;
      display: block;
      margin-top: -6px;
    }
    .form-item .unit {
      position: absolute;
      right: 10px;
      top: 0px;
      z-index: 2;
      font-size: 14px;
      color: #999;
      line-height: 40px;
    }
    .sp-select{
      width: 100%;
    }
  }
  .product-box{
    border: 1px solid #e5e5e5;
    padding: 10px 30px;
    float: right;
    min-height: 40px;
    position: relative;
    overflow: hidden;
    width: 600px;
    margin-bottom: 10px;
    .btn-remove{
      position: absolute;
      right: -30px;
      top: -30px;
      width: 60px;
      height: 60px;
      background-color: #f75959;
      color: #fff;
      font-size: 12px;
      line-height: 100px;
      text-align: center;
      transform: rotate(45deg);
      cursor: pointer;
    }
    .sp-select{
      margin-bottom: 10px;
      .el-input__inner{
        background-color: #f9f9f9;
      }
      &.project{
        .el-input__inner{
          background-image: url('~@/assets/createOrder/icon-project.png');
          background-repeat: no-repeat;
          background-position: 440px center;
          background-size: 60px 14px;
        }
      }
      &.standard{
        .el-input__inner{
          background-image: url('~@/assets/createOrder/icon-standard.png');
          background-repeat: no-repeat;
          background-position: 440px center;
          background-size: 60px 14px;
        }
      }
    }
    .input-info{
      margin-bottom: 10px;
    }
    .input-box{
      width: 100%;
    }
    .input{
      background-color: #f9f9f9;
    }
  }
  .tab-hd{
    white-space: nowrap;
    width: 100%;
    text-align: center;
    .tab-item {
      display: inline-block;
      position: relative;
      // width: 130px;
      height: 32px;
      overflow: hidden;
      margin-bottom: 10px;
      margin-right: 60px;
      &:nth-child(5n) {
        margin-right: 0;
      }
      input {
        /* width: 100%;
            height: 100%; */
        position: absolute;
        left: 0;
        top: 0;
        z-index: 3;
        opacity: 0;
        /* filter: Alpha(opacity=0); */
      }
      .tab-val {
        display: block;
        width: 100%;
        height: 100%;
        border-bottom: 2px solid transparent;
        text-align: center;
        line-height: 32px;
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }
    }
    .tab-val.checked,
    .tab-item input:checked + .tab-val {
      color: #f75959;
      border-color: #f75959;
    }
  }
  
  .img-list{
    display:inline-block;
    overflow:hidden;
    >li{
      width:80px;
      height:80px;
      overflow:hidden;
      float:left;
      margin-right:10px;
      margin-bottom: 10px;
      position:relative;
    }
    img{
      width:100%;
      height:100%;
      display:block;
    }
    .icon-close{
      color:#fff;
      position:absolute;
      right:0;
      top:0px;
      z-index:2;
      font-size:16px;
      line-height:20px;
      text-align:center;
      cursor:pointer;
      background-color:rgba(0,0,0,0.8);
      width:20px;
      height:20px;
    }
  }
  .module-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    color: #333;
    background-color: #f1f1f1;
    margin-bottom: 10px;
  }
  .special-demand {
    margin-top: 33px;
    margin-bottom: 70px;
    .demand-list {
      margin-bottom: 9px;
      .demand-title {
          font-size: 14px;
          line-height: 20px;
          font-weight: bold;
          color: #333;
          line-height: 44px;
      }
    }
  }
  .special-cell{
    overflow: hidden;
    width: 100%;
    margin-bottom: 20px;
    .label{
      float: left;
      width: 560px;
      font-size: 14px;
      color: #333;
      line-height: 24px;
      overflow: hidden;
      word-break: break-all;
    }
    .radio-group{
      float:right;
      overflow: hidden;
    }
    .radiobox{
      position: relative;
      overflow: hidden;
      margin-left: 10px;
      cursor: pointer;
    }
    .radio{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      font-size: 100px;
      opacity: 0;
    }
    .radio-text{
      font-size: 14px;
      color: #333;
      line-height: 24px;
      padding-left: 20px;
      position: relative;
    }
    .radio-text:before{
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      border: 1px solid #999;
      padding: 2px;
      background-color: #fff;
      box-sizing: border-box;
      margin-top: -7px;
    }
    .radio:checked+.radio-text:before{
      border-color: #f75959;
      background-color: #f75959;
      background-clip: content-box;
    }
    .requirement{
      float: left;
      width: 100%;
      height: 40px;
      padding: 8px 10px;
      border: 1px solid #e3e3e3;
      font-size: 14px;
      color: #333;
      line-height: 22px;
      margin-top: 10px;
    }
  }
 
  .jobTypeDesc{
   width:100%;
   font-size: 14px;
    color: #606266;
    margin-top: 10px;
   td{
    padding: 5px;
    border: 1px solid #ebeef5;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    line-height: 23px;

     i {
      // color: #409eff;
      color: #f75959;
      font-weight: bold;
    }
    span.thr{
      text-decoration:line-through
    }

   }
   td.no{
    color: #606266;
   }

  }
 


}
.el-select-dropdown__item{
  .icon-standard{
    float: right;
    width: 60px;
    height: 14px;
    background: url('~@/assets/createOrder/icon-standard.png') no-repeat center;
    background-size: contain;
    margin-top: 10px;
  }
  .icon-project{
    float: right;
    width: 60px;
    height: 14px;
    background: url('~@/assets/createOrder/icon-project.png') no-repeat center;
    background-size: contain;
    margin-top: 10px;
  }
}
.guide-box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;
  img {
    position: absolute;
    left: 50%;
    top: 428px;
    width: 645px;
    height: 108px;
    margin-left: -126px;
  }
}
.qrcode-dialog {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  .inner {
    width: 300px;
    height: 350px;
    text-align: center;
    border-radius: 10px;
    background-color: #fff;
    padding: 10px 20px;
    box-shadow: 1px 4px 18px 1px rgba(0, 0, 0, 0.1);
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -200px;
  }
  .hide-input {
    position: fixed;
    left: -99999px;
    top: -2000px;
  }
  .btn-copy {
    width: 70px;
    height: 24px;
    border-radius: 20px;
    text-align: center;
    position: absolute;
    right: 17px;
    top: 15px;
    font-size: 14px;
    line-height: 22px;
    color: #000;
    border: 1px solid #9a9a9a;
    cursor: pointer;
    user-select: none;
  }
  .qrcode {
    width: 142px;
    height: 142px;
    display: block;
    margin: 40px auto 5px;
  }
  .desc {
    font-size: 14px;
    color: #333;
    line-height: 20px;
  }
  .btn-primary {
    display: block;
    width: 150px;
    height: 40px;
    background: #f75959;
    border-radius: 2px;
    font-family: inherit;
    color: #fff;
    text-align: center;
    cursor: pointer;
    border: 1px solid #f75959;
    margin: 24px auto 10px;
  }
}
.el-select-dropdown{
  .parent{
    font-size: 14px;
  }
  .child{
    font-size: 12px;
    padding-left: 10px;
  }
  i{
    color: #f75959;
  }
}
.select-service {
  .el-dialog__body {
    padding: 0 48px 30px;
  }
  .service-center {
    .servie-list {
      li {
        width: 200px;
        height: 278px;
        background: #FFFFFF;
        border: 1px solid #E3E3E3;
        .servie-pic {
          width: 138px;
          height: 138px;
        }
        h3 {
          width: 168px;
          font-size: 14px;
        }
        p {
          width: 168px;
        }
        .servie-tag {
          margin-left: 16px;
        }
      }
    }
  }
   
}


// .rich:empty:before{
//     content: attr(placeholder);   /* element attribute*/
//     /*content: 'this is content';*/
//     color: #c3c6cf;
//     line-height: 40px;
    
// }
// .rich:focus-visible {
//   outline:none;
//   line-height: 40px;
// }
// /*焦点时内容为空*/
// .rich:focus:before{
//     content:none;
//     line-height: 40px;
// }


</style>
